(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["past-live-session"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Add responsive iframe resizing if needed
  function resizeIframes() {
    const videoContainers = document.querySelectorAll('.video-iframe-container');
    videoContainers.forEach(container => {
      // Make sure iframes maintain aspect ratio on window resize
      const width = container.offsetWidth;
      const height = width * 0.5625; // 16:9 aspect ratio
    });
  }
  
  // Call on load and resize
  window.addEventListener('resize', resizeIframes);
  resizeIframes();
});

  } catch(e) { console.error(e); }
})();
})();
